import React from 'react';
import CompanyWithLocs from './displayCompanyWithLocs';
import { Card, CardHeader, CardText, Paper, FontIcon } from 'material-ui';
import R from 'ramda';
import pluralize from 'pluralize';

const Followers = ({ followers }) => {
  return (
    <div style={{ width: '60%', margin: '24px auto' }}>
      {
        followers.map(({ locationId, name, connectedCompanyWithLocs }) => {
          const numOfCompanies = R.length(connectedCompanyWithLocs);
          const totalLocs = R.length(R.chain(R.prop('locations'), connectedCompanyWithLocs));
          return (
            <Card
              key={locationId}
              style={{ width: '90%', margin: '24px auto 0 0' }}
              expandable
            >
              <CardHeader
                actAsExpander
                showExpandableButton
                avatar={<FontIcon className="tc-icon-location_on" />}
                title={`${name} : ${numOfCompanies} ${pluralize('company', numOfCompanies)}, ${totalLocs} ${pluralize('location', totalLocs)}`}
              />
              <CardText style={{ paddingLeft: '32px' }} expandable>
                {
                  connectedCompanyWithLocs.map((companyWithLocs) => (
                    <CompanyWithLocs key={companyWithLocs.companyId} {...companyWithLocs}/>
                  ))
                }
              </CardText>
            </Card>
          );
        })
      }
    </div>);
};

export default Followers;



// WEBPACK FOOTER //
// ./src/app/components/newsfeed/ownerMetaDataPages/followers.jsx